import { Flex, TextV2, ButtonV2, IconV2 } from '@withjoy/joykit';
import React from 'react';
import { ReactComponent as EditIcon } from '@assets/icons/edit-icon.svg';
import { PriceSummaryLineItem } from '../../PriceSummary/PriceSummary.types';

export interface ReceiptBlockProps {
  title: string;
  subTitle?: string;
  onEditButtonClick?: () => void;
  lines: Array<PriceSummaryLineItem>;
}

const ReceiptBlock: React.FC<ReceiptBlockProps> = ({ title, subTitle, onEditButtonClick, lines }) => {
  return (
    <Flex flexDirection="column">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        marginBottom={subTitle ? 1 : 5}
      >
        <TextV2 typographyVariant="hed1">{title}</TextV2>
        {onEditButtonClick && (
          <ButtonV2
            size="sm"
            variant="link"
            intent="neutral"
            fontSize="13px"
            onClick={onEditButtonClick}
          >
            <IconV2
              size={11}
              marginRight="3px"
            >
              <EditIcon
                width="11px"
                height="11px"
              />
            </IconV2>
            Edit
          </ButtonV2>
        )}
      </Flex>
      {subTitle && (
        <TextV2
          typographyVariant="hed1"
          marginBottom={5}
        >
          {subTitle}
        </TextV2>
      )}
      <Flex
        flexDirection="column"
        rowGap={3}
      >
        {lines.map((line, index) => {
          const [label, value, options] = line;
          return (
            <Flex
              key={index}
              justifyContent="space-between"
              color={options?.highlight ? '#4951EF' : 'mono12'}
              gap={6}
              fontWeight={options?.highlight ? 600 : undefined}
            >
              <TextV2
                typographyVariant="label2"
                fontWeight="inherit"
              >
                {label}
              </TextV2>
              <TextV2
                typographyVariant="label2"
                fontWeight="inherit"
              >
                {value}
              </TextV2>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default ReceiptBlock;
